<template>
    <div v-show="visible" >
        <div :class="alertClass">
            <b-icon :icon="alertIcon" class="me-2 alert-icon"/>
            <span class="alert-message">{{message}}</span>
            <div class="flex-grow-1"></div>
            <a @click="dismissAlert" class="alert-close ms-2">
                <b-icon icon="x-lg" variant="secondary"/>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AlertDismiss',

    data() {
        return {
            message: '',
            typeAlert: 'warning',
            visible: false,
            timer: null
        }
    },

    methods: {
        showAlert(message, type) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            
            this.message = message;
            this.typeAlert = type ?? 'warning';
            this.visible = true;

            this.timer = setTimeout(() => {
                this.visible = false;
                this.timer = null;
            }, 4000);
        },

        dismissAlert() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.visible = false;
        }
    },

    computed: {
        alertClass() {
            return 'align-items-center d-flex mb-2 alert alert-' + this.typeAlert
        },

        alertIcon() {
            switch(this.typeAlert) {
                case 'success':
                    return 'check-circle-fill';
                case 'danger':
                    return 'x-circle-fill';
                case 'warning':
                    return 'exclamation-triangle-fill'; 
                case 'info':
                    return 'info-circle-fill';
                default:
                    return 'bell-fill';
            }
        },
    },

    beforeDestroy() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
}
</script>

<style scoped>

.alert {
    padding: 0.6rem;
    font-size: 0.9rem;
    font-weight: 500;
    border-radius: 4px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
}

.alert-icon {
    font-size: 1.2rem;
}

.alert-message {
    line-height: 1.5;
}

.alert-close {
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s;
}

.alert-close:hover {
    opacity: 1;
}
</style>
